<template>
  <div class="Inside_line_detail" :style="screenHeight">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="userName" placeholder="请输入联系人" title="联系人" clearable/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="telephone" placeholder="请输入联系号码" title="联系号码" clearable/>
      </div>
       <div class="fixed_search_input">
        <Input v-model="note" placeholder="请输入备注" title="备注" clearable/>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
      </div>
    </div>
    <div class="public_btn">
                <Button  class="search_btn template_btn"   v-if="roleList['9_5-1']" @click="addmail">添加</Button>
                <Button  class="search_btn template_btn" v-if="roleList['9_5-2']" @click="importmail">导入</Button>
                <Button  class="search_btn template_btn" v-if="roleList['9_5-3']" @click="exportmail">导出</Button>
                <Button  class="search_btn template_btn" v-if="roleList['9_5-4']" @click="batchdeletionmail">批量删除</Button>
    </div>
    <div class="fixed_table">
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe ref="selection"  @cell-click="openonlynumber" :cell-class-name="showonlynumber"  @selection-change="getSelectedId" >
        <el-table-column v-for="(item, index) in fieldList" align="center" :show-overflow-tooltip="true" :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width">

        </el-table-column>
        <el-table-column fixed="right" label="操作"  align="center" v-if="roleList['9_5-5'] || roleList['9_5-6']" >
          <template slot-scope="scope">
            <el-button  @click="editmail(scope.row.id,scope.row.telephone,scope.row.userName,scope.row.note)" type="text" size="small"  v-show="roleList['9_5-5']">编辑</el-button>
            <el-button  @click="deletemail(scope.row.id)" type="text" size="small"  v-show="roleList['9_5-6']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Spin size="large" fix v-if="spinShow">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>正在加载中...</div>
      </Spin>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size="pageSize" :current="currentPage" :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px">跳至</div>
      <Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/>
      <div style="padding-top: 2px">页</div>
    </div>
    <AddmailPop :showaddmail="showaddmail" :maillistId="maillistId" :maillistname="maillistname" :maillisttel="maillisttel" :maillistnote="maillistnote"  @closeaddmailPop="closeaddmailPop" ></AddmailPop>
    <DeletmailPop :showdeletmailPop="showdeletmailPop" @closedeletmailPop="closedeletmailPop"></DeletmailPop>
    <ImportmailPop @closemailImport="closemailImport" :showmailImport="showmailImport"></ImportmailPop>
    <ExportmailPop @closemailExport="closemailExport" :showmailExport="showmailExport"></ExportmailPop>
      <publicDialerPage @closePublicDialerPage="closePublicDialerPage" :showPublicDialer="showPublicDialer" :callUpPhone="callUpPhone"></publicDialerPage>
    <PublicSendMessage @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage" :callUpPhone="callUpPhone"></PublicSendMessage>
  </div>
</template>

<script>
import {publicFunClass} from "@/components/js/PublicFunClass.js"
import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
import AddmailPop from '@/components/userManagement/AddmailPop.vue'
import DeletmailPop from '@/components/userManagement/DeletmailPop.vue'
import ImportmailPop from '@/components/userManagement/ImportmailPop.vue'
import ExportmailPop from '@/components/userManagement/ExportmailPop.vue'
import publicDialerPage from '@/components/login/PublicDialerPage.vue'
  import PublicSendMessage from '@/components/login/PublicSendMessage.vue'
export default {
  name: "MailList",
  mixins:[publicFunClass,customerPublicBtn],
  components: {
    AddmailPop,
    DeletmailPop,
    ImportmailPop,
    ExportmailPop,
     publicDialerPage,
      PublicSendMessage
  },
  props: {
    pageCode: String,
  },
  data() {
    return {
      showPageCount: 0,
      roleList: JSON.parse(localStorage.getItem("roleList")),
      screenHeight: { height: "" },
      tableHeight: 600,
      total: 0,
      pageSizeList: [10, 20, 30, 40, 50, 100, 200],
      currentPage: 1,
      pageSize: 20,
      speedChangePage: 1,
      spinShow: false,
      checkedAll: false,

      telephone: "",
      userName: "",
      note:"",
      fieldList: [
        { type: "selection", width: 50 },
        {  key: "userName", title: "联系人" },
        {  key: "telephone", title: "联系号码" },
        { key: "note", title: "备注" },
      ],
      contentList: [],
      checkIds: [],
      journalType: "null",
      menuId: "null",
      showaddmail:false,
      maillistId:'',
      maillisttel:'',
      maillistname:'',
      maillistnote:'',
      showdeletmailPop:false,
      showmailImport:false,
      showmailExport:false,
      tableClass: true,
      queryParam: null,
    };
  },
  methods: {

    openonlynumber:function(row, column){
        if(!column.property){
          return false;
        }
        if(column.property.indexOf("telephone")!=-1){
          this.messageOrPhone(row.telephone);
        }
    },
    showonlynumber:function(event){
        if(event.column.property){
          if(event.column.property.indexOf("telephone")!=-1){
            return 'telephone'
          }
        }
    },
    initSearch: function () {
        let that=this;
        let param={
          telephone:this.telephone,
          userName:this.userName,
          note:this.note,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          journalType:"null",
          menuId:"null",
        };
        this.spinShow=true;
        this.queryParam = param;

        this.$http.post("externalAddressBook/toIndex.json",param) .then(function (res) {
          let result=res.data;
          that.spinShow=false;
          if(result.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.checkIds=[];
          that.contentList=res.data.obj.list.content;
          that.total=res.data.obj.list.totalSize;
        })
    },
    reset: function () {
        this.telephone="";
        this.userName="";
        this.note="";
    },
    //添加
    addmail:function () {
            this.maillistId='';
            this.maillisttel='';
            this.maillistname='';
            this.maillistnote='';
            this.showaddmail=true;
    },
    //关闭添加编辑的
    closeaddmailPop:function(flag){
      this.showaddmail=false;
      if(flag){
        this.initSearch();
      }
    },
    //编辑通讯录
    editmail:function (id,tel,name,note) {
            this.maillistId=id+'';
            this.maillisttel=tel;
            this.maillistname=name;
            this.maillistnote=note;
            this.showaddmail=true;
    },
     //删除
    deletemail:function (id) {
            let that=this;
            let param={
                journalType:"用户管理=>通讯录=>删除",
                menuId:"9_5-6",
                type:"0",//单条删除type为0选中
                ids:id,
              };
            this.$Modal.confirm({
              title: '提示',
              content: "是否确定删除",
              onOk: () => {
                that.$http.post("externalAddressBook/doDeletes.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("删除成功");
                  that.initSearch();
                });
              }
            });
    },
    //批量删除
    batchdeletionmail:function () {
      this.showdeletmailPop=true;
    },
    //关闭批量删除后
    closedeletmailPop:function(flag,deletemailStyle){//后两个参数为: 选择按结果0/按搜索1    黑名单1/白名单2
            this.showdeletmailPop=false;
            if (flag) {
              let param=[];
              if (deletemailStyle=='0'){//选中结果删除
                if (this.checkIds.length==0){
                  this.$Modal.info({
                    title:'提示',
                    content:"当前无可删除的数据"
                  });
                  return false;
                }
                 param={
                  type:deletemailStyle,//1搜索 0选中
                  ids:this.checkIds.toString(),
                  journalType:"用户管理=>通讯录=>批量删除",
                  menuId:"9_5-4",
                };
              }
              if (deletemailStyle=='1'){//搜索结果删除
                if(this.contentList.length==0){
                  this.$Modal.info({
                    title:'提示',
                    content:"当前无可删除的数据"
                  });
                  return false;
                }
                if(!this.queryParam){
                    this.$Modal.info({
                      title:'提示',
                      content:"请点击查询后再删除"
                    });
                    return false;
                }

                delete this.queryParam["pageNum"];
                delete this.queryParam["pageSize"];

                this.$set(this.queryParam, 'type', deletemailStyle);
                this.$set(this.queryParam, 'journalType', "用户管理=>通讯录=>批量删除");
                this.$set(this.queryParam, 'menuId', "9_5-4");
                param = this.queryParam;
              }
              let that=this;
              that.$Modal.confirm({
                    title: '提示',
                    content: "是否确定删除",
                    onOk: () => {
                      that.$http.post("externalAddressBook/doDeletes.json",param) .then(function (res) {
                        let result = res.data.flag;
                        if(result!="666"){
                          that.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定'
                          });
                          return false;
                        }
                        that.$Message.info("删除成功");
                        that.initSearch();
                      });
                    }
              });
            }
      },

    //导入
    importmail:function(){
      this.showmailImport=true
    },
    //导入回调函数
    closemailImport:function(flag){
      this.showmailImport=false
      if(flag){
        this.initSearch();
      }
    },
    //导出
    exportmail:function(){
            this.showmailExport=true
    },
    //关闭导出
    closemailExport:function (flag,operateStyle) {

              this.showmailExport=false;
              let that=this;
              if (flag) {
                if (operateStyle=='0'){//选中结果
                  if (this.checkIds.length==0){
                    this.$Modal.info({
                      title:'提示',
                      content:"当前无可导出的数据"
                    });
                    return false;
                  }
                  let param={
                    ids:this.checkIds.toString(),
                    type:operateStyle,
                    journalType:"用户管理=>通讯录=>按选中结果导出",
                    menuId:"9_5-3",
                  };
                  let url="externalAddressBook/exportExternalAddressBook.json";
                  that.$Loading.start();
                  that.operateExcelExport(param,url)
                }
                if (operateStyle=='1'){//按搜索结果
                  if(this.contentList.length==0){
                    this.$Modal.info({
                      title:'提示',
                      content:"当前无可导出的数据"
                    });
                    return false;
                  }
                  if(!this.queryParam){
                    this.$Modal.info({
                      title:'提示',
                      content:"请点击查询后再删除"
                    });
                    return false;
                }

                delete this.queryParam["pageNum"];
                delete this.queryParam["pageSize"];

                this.$set(this.queryParam, 'type', operateStyle);
                this.$set(this.queryParam, 'journalType', "用户管理=>通讯录=>按搜索结果导出");
                this.$set(this.queryParam, 'menuId', "9_5-3");
                
                  let url="externalAddressBook/exportExternalAddressBook.json";
                  that.$Loading.start();
                  that.operateExcelExport(this.queryParam,url);
                }
              }
    },



  },
  created() {
    this.screenHeight.height = this.mountHeight(91);
    let clientHeight = document.documentElement.clientHeight;
    this.tableHeight = clientHeight - 232;
  },
  watch: {
    pageCode: function () {
      if (this.pageCode == "9_5" && this.showPageCount == 0) {
        this.showPageCount++;
        this.initSearch();
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/userManagement/MailList.vue